import { LoadingStates } from '@pb/utils'

export default {
  iafLabelsStatus: LoadingStates.NotLoaded,
  iafLabels: [],
}
